import styled from 'styled-components'

export const Tag = styled.div`
  border-radius: 4px 0 0 4px;
  border-left: 4px solid ${({ theme }) => theme.colors.icon.default};
  width: 100%;
`
